$(document).ready(function() {
	
	$(document).on('click', '.js-vi-button', function() {
		if ($('.b-vi-top-control').is(":hidden")) {
			$('.b-vi-top-control').show();
		} else {
			$('.b-vi-top-control').hide();
		}
		$('body').toggleClass('visually-impaired');
	});

	$(document).on('click', '.b-vi-top-control__version', function() {
		$('.b-vi-top-control').hide();
		$('body').removeClass('visually-impaired');
	});
});


// WEBPACK FOOTER //
// ./src/js/visually-impaired/open.js